import { useEffect, useState } from "react";
import { Container, Card, Button, Table, Modal, Form, Row, Col, Badge } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
//Components 
import NavBar from "../../NavBar/Navbar";
import AssignProductsToRuleEvent from "./AssignProductsToRuleEvent";
//API
import { EventsFetchAPI } from "../../../api/Events";
import { PickNGoFetchAPI } from "../../../api/PickAndGo";
//Utils
import { RenderIf } from "../../utils/RenderIf";
import { buildCloudinaryImageUrl } from "../../utils/CloudinaryImageUrl";
//Alerts
import SuccessAlert from "../../Alerts/SuccessAlert";
import ErrorAlert from "../../Alerts/ErrorAlert";
import AlertSmall from "../../Alerts/AlertSmall";

const EMPTY = {
    id: null, business_id: "", branchoffice_id: null,
    slot_minutes: 30, window_start: "8:00", window_end: "17:00",
    days_ahead: 7, lead_time_minutes: 60, is_active: true, priority: 100,
    type: "all"
};

const RulesByEvent = () => {

    const { event_id } = useParams();
    const [rows, setRows] = useState([]);
    const [show, setShow] = useState(false);
    const [editing, setEditing] = useState(null);
    const business = JSON.parse(localStorage.getItem('user'))?.business || {};
    const token = localStorage.getItem('x-access-token');
    const branches = JSON.parse(localStorage.getItem('user'))?.branchoffices || [];
    const [showProducts, setShowProducts] = useState(false);
    const [ruleForProducts, setRuleForProducts] = useState(null);
    const [eventInfo, setEventInfo] = useState(null);
    const [events, setEvents] = useState([]);
    const [eventName, setEventName] = useState("")
    const [showModalEventSelect, setShowModalEventSelect] = useState(false);
    /**
     * Load the pick and go rules for the business
     */
    const getRulesByEvent = async (id) => {
        try {
            const res = await EventsFetchAPI.getRuleByEventId(id, token);
            const data = res?.data?.rules || res?.data || [];
            setRows(Array.isArray(data) ? data : []);
        } catch (e) { ErrorAlert("No se pudo cargar", "Reglas de evento", "warning"); setRows([]); }
    };

    const getEventsByBusinessId = async () => {
        try {
            const res = await EventsFetchAPI.getEventsByBusiness(business.id, token);
            console.log(res.data.events);
            setEvents(res.data.events);

            if (event_id) {
                const eventSelected = res.data.events.find(ev => Number(ev.id) === Number(event_id));
                if (eventSelected) {
                    safeSelect(eventSelected);
                }
            }
        } catch (e) {
            console.log(e);
        }
    }

    const safeSelect = (event) => {
        if (event == 0) {
            setShowModalEventSelect(false)
            localStorage.setItem("branchoffice", 0);
            setEventName("Selecciona un evento")
        } else {
            setShowModalEventSelect(false)
            getRulesByEvent(event.id);
            setEventName(event.name)
            setEventInfo(event);
        }

    }

    {/*view eventse*/ }
    const viewEvents = () => {
        const listItems = events.map((event, index) => (
            <>
                {/* <div className='m-3'>
                    <div className='btn btn-outline-primary  d-block border border-3 rounded-pill p-3 ' onClick={() => (safeSelect(branch))}>
                        <span className='p-3  text-wrap px-3'>{branch.branchoffice_name}</span>
                    </div>
                </div> */}
                <input type="radio" className="btn-check" name="items-branchs" id={event.name + index} onClick={() => (safeSelect(event))}

                />
                <label className="btn-branchs card-title rounded-3  p-2 border border-primary text-center fw-semibold w-100 text-primary" translate='no' role='button'
                    for={event.name + index}>
                    <span> {event.name}</span>
                </label>

            </>
        ));
        return (listItems)
    }


    const getEvent = async (id) => {
        try {
            const response = await EventsFetchAPI.getEventById(event_id, token);
            setEventInfo(response.data.event[0]);
            getRulesByEvent()
        } catch (e) {
            ErrorAlert("No se pudo cargar el evento", "Error", "warning");
        }
    }


    /**
     * Hook to load the pick and go rules on component mount
     */
    useEffect(() => { getEventsByBusinessId(); }, []);

    const openCreate = () => { setEditing({ ...EMPTY, business_id: business.id }); setShow(true); };
    const openEdit = (r) => { setEditing({ ...EMPTY, ...r, is_active: !!r.is_active }); setShow(true); };

    const save = async () => {
        try {
            const payload = {
                ...editing,
                business_id: Number(editing.business_id),
                name: editing.name?.trim() || 'Sin nombre',
                branchoffice_id: editing.branchoffice_id ? Number(editing.branchoffice_id) : null,
                slot_minutes: Number(editing.slot_minutes),
                lead_time_minutes: Number(editing.lead_time_minutes),
                is_active: editing.is_active ? 1 : 0,
                priority: editing.priority ? Number(editing.priority) : 100,
                type: editing.type || "all",
                limit_mode: editing.limit_mode || "days_ahead",
                days_ahead: (editing.limit_mode || "days_ahead") === "days_ahead"
                    ? Number(editing.days_ahead)
                    : null,
                start_date: (editing.limit_mode || "days_ahead") === "date_range"
                    ? editing.start_date || null
                    : null,
                end_date: (editing.limit_mode || "days_ahead") === "date_range"
                    ? editing.end_date || null
                    : null,
                event_id: eventInfo.id,
            };
            if (editing.id) await EventsFetchAPI.updateEventRules(editing.id, payload, token);
            else await EventsFetchAPI.createEventRules(payload, token);

            SuccessAlert("Configuración guardada", "Listo");
            setShow(false);
            // We reload the rules
            getRulesByEvent(eventInfo.id);
        } catch (e) { ErrorAlert(e?.response?.data?.error || "Error guardando", "Reglas de evento", "warning"); }
    };

    const openProducts = (r) => {
        setRuleForProducts({ id: r.id, name: r.name || `Regla #${r.id}` });
        setShowProducts(true);
    };

    const deleteRule = async (r) => {
        try {
            const response = await EventsFetchAPI.deleteEventRules(r.id, token);
            ErrorAlert("Regla eliminada", "Listo", "success");
            getRulesByEvent(eventInfo.id);
        } catch (e) {
            ErrorAlert(e?.response?.data?.error || "Error al eliminar", "Reglas de evento", "warning");
            console.log(e);
        }
    }

    return (
        <>
            {/** Navbar */}
            <NavBar titlePage="Pick & Go Manager" />
            {/**Content */}
            <Container className="py-3">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <button class="btn-branchs card-title rounded-3  p-1 border border-primary text-center " onClick={() => (setShowModalEventSelect(true))}>
                        <small class="d-block fw-semibold" role='button'>
                            <i class="uil uil-store-alt"></i> Evento</small>
                        <span class="fw-semibold" role='button' >
                            {eventName || "Selecciona un evento"}
                        </span>
                    </button>
                    <Button onClick={openCreate}>+ Nueva</Button>
                </div>

                {/* Contenedor de información del evento */}
                {eventInfo && (

                    <Card className="mb-4">
                        <Card.Body>
                            <h5 className="mb-3 text-primary">Información del Evento</h5>
                            <div className="d-flex flex-wrap gap-2 mb-3">
                                <div className="border rounded p-2 bg-light">
                                    <span className="fw-bold text-secondary">ID Evento:</span><br />
                                    <span className="fs-5">#{eventInfo.id}</span>
                                </div>
                                <div className="border rounded p-2 bg-light">
                                    <span className="fw-bold text-secondary">Nombre:</span><br />
                                    <span className="fs-5">{eventInfo.name}</span>
                                </div>
                                <div className="border rounded p-2 bg-light">
                                    <span className="fw-bold text-secondary">Código:</span><br />
                                    <span className="fs-5">{eventInfo.code}</span>
                                </div>
                                <div className="border rounded p-2 bg-light">
                                    <span className="fw-bold text-secondary">Estado:</span><br />
                                    <span className="fs-5">{eventInfo.state === 1 ? "Activo" : "Inactivo"}</span>
                                </div>
                            </div>
                            <div className="mb-3">
                                <span className="fw-bold text-secondary">Descripción:</span><br />
                                <span>{eventInfo.description || "Sin descripción"}</span>
                            </div>
                            <div className="mb-2">
                                <span className="fw-bold text-secondary">Fechas del evento:</span>
                                {eventInfo.dates && eventInfo.dates.length > 0 ? (
                                    <div className="d-flex flex-wrap gap-2 mt-2">
                                        {eventInfo.dates.map(date => (
                                            <div key={date.id} className="border rounded p-2 bg-white" style={{ minWidth: '180px' }}>
                                                <div><span className="fw-bold">Inicio:</span> {new Date(date.initialDate).toLocaleDateString()}</div>
                                                <div><span className="fw-bold">Fin:</span> {new Date(date.maxDate).toLocaleDateString()}</div>
                                                <div><span className="fw-bold">Tipo:</span> {date.type}</div>
                                                <div><span className="fw-bold">Descripción:</span> {date.description || "Sin descripción"}</div>
                                                {date.img && <img src={buildCloudinaryImageUrl({ url: date.img, width: 300, quality: "auto", type: "image" })} alt="img" style={{ maxWidth: '80px', marginTop: '5px' }} />}
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <span className="text-muted ms-2">Sin fechas registradas</span>
                                )}
                            </div>
                        </Card.Body>
                    </Card>
                )}
                <Card><Card.Body>
                    <Table size="sm" hover>
                        <thead>
                            <tr>
                                <th>Activa</th>
                                <th>Sucursal</th>
                                <th>Nombre</th>
                                <th>Duración de cada ventana (minutos)</th>
                                <th>Horario de disponibilidad</th>
                                <th>Días disponibles (para reservar)</th>
                                <th>Anticipación mínima para pedir (minutos)</th>
                                <th>Prioridad</th>
                                <th>Tipo de regla</th>
                                <th>Modo de límite</th>
                                <th>Acciones</th>


                            </tr>
                        </thead>
                        <tbody>
                            {rows.map(r => (
                                <tr key={r.id}>
                                    <td>{Number(r.is_active) ? <Badge bg="success">Sí</Badge> : <Badge bg="secondary">No</Badge>}</td>
                                    <td>{r.name}</td>
                                    <td>{r.branchoffice_name ?? "General negocio"}</td>
                                    <td>{r.slot_minutes}</td>
                                    <td>{r.window_start}–{r.window_end}</td>
                                    <td>
                                        {r.limit_mode === "date_range"
                                            ? `${r.start_date.slice(0, 10) || '-'} a ${r.end_date.slice(0, 10) || '-'}`
                                            : `${r.days_ahead} día(s)`}
                                    </td>
                                    <td>{r.lead_time_minutes}</td>
                                    <td>{r.priority}</td>
                                    <td>{r.type === "all" ? "Toda la orden" : "Solo productos asignados"}</td>
                                    <td>{r.limit_mode === "date_range" ? "Rango de fechas" : "Días a futuro"}</td>
                                    <td className="text-end">
                                        <Button className="m-1" size="sm" variant="outline-primary" onClick={() => openEdit(r)}>Editar</Button>
                                        <Button className="m-1" size="sm" variant="outline-danger" onClick={() => deleteRule(r)}><i class="uil uil-trash"></i></Button>
                                        <RenderIf isTrue={r.type === "product"}>

                                            <Button size="sm" variant="outline-primary" onClick={() => openProducts(r)}>Agregar productos</Button>
                                        </RenderIf>
                                    </td>
                                </tr>
                            ))}
                            {!rows.length && <tr><td colSpan={7} className="text-center text-muted">Sin configuraciones</td></tr>}
                        </tbody>
                    </Table>
                </Card.Body></Card>
                {/**Modal to create and edit configurations */}
                <Modal show={show} onHide={() => setShow(false)} centered>
                    <Modal.Header closeButton><Modal.Title>{editing?.id ? 'Editar' : 'Nueva'} Configuración</Modal.Title></Modal.Header>
                    <Modal.Body>
                        {editing && (


                            <Form>
                                <Row className="g-3">
                                    <Col md={12}>
                                        <Form.Label>Sucursal</Form.Label>
                                        <Form.Select
                                            value={editing.branchoffice_id ?? 'null'}
                                            onChange={e => setEditing({ ...editing, branchoffice_id: e.target.value === 'null' ? null : e.target.value })}
                                        >
                                            <option value="null">General del negocio</option>
                                            {branches.map(b => (
                                                <option key={b.branchoffice_id} value={b.branchoffice_id}>{b.branchoffice_name}</option>
                                            ))}
                                        </Form.Select>
                                    </Col>
                                    <Col md={12}>
                                        <Form.Label>Nombre</Form.Label>
                                        <Form.Control type="text" value={editing.name || ''}
                                            onChange={e => setEditing({ ...editing, name: e.target.value })} />
                                    </Col>

                                    <Col md={4}>
                                        <Form.Label>Lapso (min)</Form.Label>
                                        <Form.Control type="number" value={editing.slot_minutes}
                                            onChange={e => setEditing({ ...editing, slot_minutes: e.target.value })} />
                                    </Col>
                                    <Col md={4}>
                                        <Form.Label>Desde</Form.Label>
                                        <Form.Control type="time" value={editing.window_start}
                                            onChange={e => setEditing({ ...editing, window_start: e.target.value })} />
                                    </Col>
                                    <Col md={4}>
                                        <Form.Label>Hasta</Form.Label>
                                        <Form.Control type="time" value={editing.window_end}
                                            onChange={e => setEditing({ ...editing, window_end: e.target.value })} />
                                    </Col>
                                    <Col md={6}>
                                        <Form.Label>Modo de límite</Form.Label>
                                        <Form.Select
                                            value={editing.limit_mode || 'days_ahead'}
                                            onChange={e =>
                                                setEditing({
                                                    ...editing,
                                                    limit_mode: e.target.value,
                                                    days_ahead: e.target.value === "days_ahead" ? (editing.days_ahead || 7) : "",
                                                    start_date: e.target.value === "date_range" ? (editing.start_date || "") : "",
                                                    end_date: e.target.value === "date_range" ? (editing.end_date || "") : ""
                                                })
                                            }
                                        >
                                            <option value="days_ahead">Días a futuro</option>
                                            <option value="date_range">Rango de fechas</option>
                                        </Form.Select>
                                    </Col>
                                    <RenderIf isTrue={(editing.limit_mode || "days_ahead") === "days_ahead"}>
                                        <Col md={6}>
                                            <Form.Label>Días a futuro</Form.Label>
                                            <Form.Control
                                                type="number"
                                                value={editing.days_ahead}
                                                onChange={e => setEditing({ ...editing, days_ahead: e.target.value })}
                                            />
                                        </Col>
                                    </RenderIf>

                                    <RenderIf isTrue={(editing.limit_mode || "days_ahead") === "date_range"}>
                                        <>
                                            <Col md={6}>
                                                <Form.Label>Fecha inicio</Form.Label>
                                                <Form.Control
                                                    type="date"
                                                    value={editing.start_date || ""}
                                                    onChange={e => setEditing({ ...editing, start_date: e.target.value })}
                                                />
                                            </Col>
                                            <Col md={6}>
                                                <Form.Label>Fecha fin</Form.Label>
                                                <Form.Control
                                                    type="date"
                                                    value={editing.end_date || ""}
                                                    onChange={e => setEditing({ ...editing, end_date: e.target.value })}
                                                />
                                            </Col>
                                        </>
                                    </RenderIf>
                                    <Col md={6}>
                                        <Form.Label>Tiempo preparación (min)</Form.Label>
                                        <Form.Control type="number" value={editing.lead_time_minutes}
                                            onChange={e => setEditing({ ...editing, lead_time_minutes: e.target.value })} />
                                    </Col>
                                    <Col md={6}>
                                        <Form.Label>Nivel de prioridad</Form.Label>
                                        <Form.Control type="number" value={editing.priority}
                                            onChange={e => setEditing({ ...editing, priority: e.target.value })} />
                                    </Col>
                                    <Col md={6}>
                                        <Form.Label>Tipo de regla</Form.Label>
                                        <Form.Select
                                            value={editing.type || 'all'}
                                            onChange={e => setEditing({ ...editing, type: e.target.value })}
                                        >
                                            <option value="all">Todos los productos</option>
                                            <option value="product">Solo productos asignados</option>
                                        </Form.Select>
                                    </Col>
                                    <RenderIf isTrue={!!editing.id}>
                                        <Col md={12}>
                                            <Form.Check type="switch" label="Activa"
                                                checked={!!editing.is_active}
                                                onChange={e => setEditing({ ...editing, is_active: e.target.checked })} />
                                        </Col>
                                    </RenderIf>
                                </Row>
                            </Form>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShow(false)}>Cancelar</Button>
                        <Button variant="primary" onClick={save}>Guardar</Button>
                    </Modal.Footer>
                </Modal>

                {/* Modal of asign products */}
                <AssignProductsToRuleEvent
                    show={showProducts}
                    onHide={() => setShowProducts(false)}
                    rule={ruleForProducts}
                    businessId={business?.id}
                    token={token}
                />
            </Container>


            <Modal
                centered
                className='modal-dialog-kk'
                size="md"
                show={showModalEventSelect}
                onHide={() => setShowModalEventSelect(false)}>
                <Modal.Body>

                    <div className='idioma-sp position-relative '>
                        <section className="form-signin-sp bg-white border-0">
                            <h2 className="title-main-login  text-center ">      <i class="uil uil-store-alt"></i>Eventos</h2>
                            <div className=' pb-4' >
                                <label className="form-label fw-normal text-gray-600">
                                    Lista de Eventos
                                </label>
                                <div className='branch-wrapper  no-scroll'>
                                    <div className='d-flex flex-column gap-3 p-2 bg-body' >
                                        <input type="radio" className="btn-check" name="items-branchs" id="all" onClick={() => (safeSelect(0))} />
                                        <label className="btn-branchs card-title rounded-3  p-2 border border-primary text-center fw-semibold w-100 text-primary" for="all" role='button'>
                                            <span>Selecciona un evento</span>
                                        </label>
                                        {viewEvents()}
                                    </div>
                                </div>
                                <div className='d-block text-center mt-3 opacity-50'>
                                    <i class="uil uil-info-circle"></i>
                                    Escoge  el evento de tu preferencia.
                                </div>
                            </div>
                        </section>
                        <div className='position-absolute top-0 start-100 translate-middle mt-2 '>
                            <div className='me-3'>
                                <button class="btn btn-outline-secondary border-0 bg-light text-secondary rounded-circle p-2 lh-1" type="button" onClick={() => (setShowModalEventSelect(false))} title='Cerrar'>
                                    <i class="uil uil-multiply"></i>
                                    <span class="visually-hidden">Dismiss</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>

    );
}

export default RulesByEvent;